import { render, staticRenderFns } from "./optionProduct.vue?vue&type=template&id=0236ca29&scoped=true"
import script from "./optionProduct.vue?vue&type=script&lang=js"
export * from "./optionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236ca29",
  null
  
)

export default component.exports